import { energyAnalysisApiSlice as api } from '../../../apiSlice';
export const addTagTypes = ['Portfolio Analysis'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSubscriptionsSubscriptionsGet: build.query<
        GetSubscriptionsSubscriptionsGetApiResponse,
        GetSubscriptionsSubscriptionsGetApiArg
      >({
        query: () => ({ url: `/subscriptions` }),
        providesTags: ['Portfolio Analysis'],
      }),
      createSubscriptionSubscriptionPost: build.mutation<
        CreateSubscriptionSubscriptionPostApiResponse,
        CreateSubscriptionSubscriptionPostApiArg
      >({
        query: (queryArg) => ({
          url: `/subscription`,
          method: 'POST',
          body: queryArg.portfolioAnalysisSubscriptionInput,
        }),
        invalidatesTags: ['Portfolio Analysis'],
      }),
      getSubscriptionSubscriptionAccountIdGet: build.query<
        GetSubscriptionSubscriptionAccountIdGetApiResponse,
        GetSubscriptionSubscriptionAccountIdGetApiArg
      >({
        query: (queryArg) => ({ url: `/subscription/${queryArg.accountId}` }),
        providesTags: ['Portfolio Analysis'],
      }),
      updateSubscriptionSubscriptionAccountIdPatch: build.mutation<
        UpdateSubscriptionSubscriptionAccountIdPatchApiResponse,
        UpdateSubscriptionSubscriptionAccountIdPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/subscription/${queryArg.accountId}`,
          method: 'PATCH',
          body: queryArg.portfolioAnalysisSubscriptionPatchInput,
        }),
        invalidatesTags: ['Portfolio Analysis'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as energyAnalysisOpenApi };
export type GetSubscriptionsSubscriptionsGetApiResponse =
  /** status 200 Successful Response */ PortfolioAnalysisSubscriptionInput[];
export type GetSubscriptionsSubscriptionsGetApiArg = void;
export type CreateSubscriptionSubscriptionPostApiResponse =
  /** status 201 Successful Response */ number;
export type CreateSubscriptionSubscriptionPostApiArg = {
  portfolioAnalysisSubscriptionInput: PortfolioAnalysisSubscriptionInput;
};
export type GetSubscriptionSubscriptionAccountIdGetApiResponse =
  /** status 200 Successful Response */ PortfolioAnalysisSubscriptionOutput;
export type GetSubscriptionSubscriptionAccountIdGetApiArg = {
  /** The ReCalc account id to get the subscription data for. */
  accountId: number;
};
export type UpdateSubscriptionSubscriptionAccountIdPatchApiResponse =
  /** status 200 Successful Response */ number;
export type UpdateSubscriptionSubscriptionAccountIdPatchApiArg = {
  /** The ReCalc account id to update. */
  accountId: number;
  portfolioAnalysisSubscriptionPatchInput: PortfolioAnalysisSubscriptionPatchInput;
};
export type PortfolioAnalysisSubscriptionInput = {
  /** The account id of the created subscription. */
  account_id: number;
  /** If the water use should be analysed. */
  water: boolean;
  /** If the heat use should be analysed. */
  heat: boolean;
  /** If the power use should be analysed. */
  power: boolean;
  /** The default daytime start. */
  default_daytime_start?: number;
  /** The default daytime end. */
  default_daytime_end?: number;
  /** If the account is a demo account. */
  demo_account?: boolean;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type PortfolioAnalysisSubscriptionOutput = {
  /** The account id of the created subscription. */
  account_id: number;
  /** If the subscription is active. */
  active: boolean;
  /** If the portfolio analysis is subscribed for power use. */
  power: boolean;
  /** If the portfolio analysis is subscribed for water use. */
  water: boolean;
  /** If the portfolio analysis is subscribed for heat use. */
  heat: boolean;
  /** If the account is new. */
  new: boolean;
  /** The default daytime start for the portfolio analysis. */
  default_daytime_start: number;
  /** The default daytime end for the portfolio analysis. */
  default_daytime_end: number;
  /** If the account is integrated. */
  integrated: boolean;
  /** If the account is a demo account. */
  demo_account: boolean;
  /** If the portfolio analysis power report is in sync. */
  power_in_sync: boolean;
  /** If the portfolio analysis heat report is in sync. */
  heat_in_sync: boolean;
  /** If the portfolio analysis water report is in sync. */
  water_in_sync: boolean;
  /** If the portfolio analysis is set to update now. */
  update_now: boolean;
  /** If the portfolio analysis metadata is set to update now. */
  update_metadata_now: boolean;
  /** If the portfolio analysis occupancy is set to update now. */
  update_occupancy_now: boolean;
  /** The number of power meters in the portfolio analysis. */
  num_power_meters: number | null;
  /** The number of heat meters in the portfolio analysis. */
  num_heat_meters: number | null;
  /** The number of water meters in the portfolio analysis. */
  num_water_meters: number | null;
};
export type PortfolioAnalysisSubscriptionPatchInput = {
  /** If the water use should be analysed. */
  water?: boolean | null;
  /** If the heat use should be analysed. */
  heat?: boolean | null;
  /** If the power use should be analysed. */
  power?: boolean | null;
  /** The default daytime start. */
  default_daytime_start?: number | null;
  /** The default daytime end. */
  default_daytime_end?: number | null;
  /** If the account is a demo account. */
  demo_account?: boolean | null;
};
export const {
  useGetSubscriptionsSubscriptionsGetQuery,
  useCreateSubscriptionSubscriptionPostMutation,
  useGetSubscriptionSubscriptionAccountIdGetQuery,
  useUpdateSubscriptionSubscriptionAccountIdPatchMutation,
} = injectedRtkApi;
